<template>
  <div class="dashboard-wrapper">
    <div class="dashboard-item" v-for="(item, index) in Object.keys(dataSeries)" :key="index">
      <div class="header">
        <div class="item-title">{{ $t(convertKeyToText(item).toLowerCase().replace(/ /g, "_")) }}</div>
        <div class="item-view-detail" @click="viewDetail(colsData, item)">{{ $t('view_detail') }}</div>
      </div>
      <div class="item-value">
        <div class="value">{{calculateTotalByField(dataSeries, item)}}</div>
        <div class="change" v-bind:class="{positive: classChange(dataSeries, item) === 'positive', negative: classChange(dataSeries, item) === 'negative'}">
          <h2>{{calculateChange(dataSeries, item)}}</h2>
          <div>{{ $t("previous_day") }}</div>
        </div>
      </div>
      <div class="item-chart">
        <UiChart :series="getSeries(dataSeries, item)" :options="tileOptions[item] || options"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiChart from '@/components/UiChart'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import i18n from '@/i18n'
export default {
  name: 'UiDashboardChart',
  components: {
    UiChart
  },
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    colsData: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    dataSeries: { type: Object, default: () => {} },
    tileOptions: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      groupedData: []
    }
  },
  computed: {
    ...mapGetters({
      getListOutLet: 'outlet/getListOutLet'
    })
  },
  methods: {
    ...mapActions({
    }),
    convertKeyToText (key) {
      return key.replace(/([A-Z])/g, ' $1').trim()
    },
    formatTotal (total, item = null) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      const toCurrency = currentCurrent?.toCurrency
      var rate = item && item.presentmentCurrency && item.currencyExchangeRate && (toCurrency === item.presentmentCurrency) ? item.currencyExchangeRate : (currentCurrent?.rate || '1')
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(6), { maxFraction: 2 })}`
    },
    formatTotalWithoutPrefix (total, currencyExchangeRate = null, presentmentCurrency = null) {
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      const toCurrencyKey = 'toCurrency'
      const toCurrency = currentCurrent[toCurrencyKey]
      var rate = presentmentCurrency && currencyExchangeRate && (toCurrency === presentmentCurrency) ? currencyExchangeRate : (currentCurrent?.rate || '1')
      return (Number(total) * Number(rate))
    },
    calculateTotalByField (dataSeries, field) {
      let result = 0
      let avgTotal = 0
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      if (field === 'orderValueByPaymentDate') {
        let rev = 0
        let cnt = 0
        dataSeries[field][0].dataTotal.forEach(item => {
          const d = item.data || {}
          rev += this.formatTotalWithoutPrefix(d.totalRevenue ? parseFloat(d.totalRevenue) : 0, d.currencyExchangeRate ? d.currencyExchangeRate : null, d.presentmentCurrency ? d.presentmentCurrency : null)
          cnt += Number(d.orderCount) || 0
        })
        const aov = cnt > 0 ? rev / cnt : 0
        return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum(Number(aov).toFixed(6), { maxFraction: 2 })}`
      }
      if (field === 'avgItemCount') {
        dataSeries[field][0].dataTotal.forEach(item => {
          avgTotal += parseFloat(item.value)
        })
        result = (avgTotal === 0 ? 0 : avgTotal / (dataSeries[field][0].dataTotal).length).toFixed(2)
      } else {
        dataSeries[field][0].dataTotal.forEach(item => {
          if (field === 'orderCount' || field === 'avgItemCount' || field === 'orderCountByPaymentDate') {
            result += parseFloat(item.value)
          } else {
            result += this.formatTotalWithoutPrefix(parseFloat(item.value ? item.value : 0), item.data && item.data.currencyExchangeRate ? item.data.currencyExchangeRate : null, item.data && item.data.presentmentCurrency ? item.data.presentmentCurrency : null)
          }
        })
      }
      if (field === 'orderCount' || field === 'avgItemCount' || field === 'orderCountByPaymentDate') {
        return result
      }
      if (field === 'avgOrderValue') {
        result = (result === 0 ? 0 : result / (dataSeries[field][0].dataTotal).length).toFixed(6)
      }
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum(Number(result).toFixed(6), { maxFraction: 2 })}`
    },
    calculateChange (dataSeries, field) {
      const fieldData = dataSeries[field][0].data
      const dataLength = fieldData.length
      let change = 0
      if (parseFloat(fieldData[dataLength - 1]) > parseFloat(fieldData[dataLength - 2])) {
        change = parseFloat(fieldData[dataLength - 2]) === 0 ? 1 : (parseFloat(fieldData[dataLength - 1]) - parseFloat(fieldData[dataLength - 2])) / parseFloat(fieldData[dataLength - 2])
      } else if (parseFloat(fieldData[dataLength - 1]) < parseFloat(fieldData[dataLength - 2])) {
        change = parseFloat(fieldData[dataLength - 1]) === 0 ? 1 : (parseFloat(fieldData[dataLength - 2]) - parseFloat(fieldData[dataLength - 1])) / parseFloat(fieldData[dataLength - 2])
      } else {
        change = 0
      }
      if (change === 0) return i18n.t('no_change')
      return (change * 100).toFixed(6) + '%'
    },
    classChange (dataSeries, field) {
      const fieldData = dataSeries[field][0].data
      const dataLength = fieldData.length
      if (parseFloat(fieldData[dataLength - 1]) > parseFloat(fieldData[dataLength - 2])) {
        return 'positive'
      } else if (parseFloat(fieldData[dataLength - 1]) < parseFloat(fieldData[dataLength - 2])) {
        return 'negative'
      }
    },
    viewDetail (colsData, item) {
      const route = colsData.find(col => col.key === item)

      this.$router.push(route.route)
    },
    getSeries(dataSeries, field) {
      const data = dataSeries[field]
      return data.map(e => ({ ...e, name: i18n.t(e.name) }))
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .dashboard-item {
    margin: 0 10px;
    padding-top: 1em;
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    background-color: #fff;
    width: calc(100% / 2 - 20px);
    margin-bottom: 20px;

    @media (min-width: 1200px) {
      width: calc(100% / 3 - 20px);
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .item-view-detail {
    padding: 0 10px;
    font-size: 14px;
    color: rgb(44, 110, 203);
    cursor: pointer;
  }

  .item-title {
    padding: 0 10px;
    margin-right: 2rem;
    margin-bottom: 25px;
    line-height: 1em;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-transform: capitalize;
  }
  .item-value {
    padding: 0 10px;
    .value {
      display: inline-block;
      font-weight: 300;
      font-size: 48px;
      letter-spacing: 0px;
      color: #555;
    }
    .change {
      font-weight: 400;
      font-size: 17px;
      margin-left: 5px;
      margin-top: 5px;
      vertical-align: top;
      display: inline-block;
      color: #b5b5b5;
      position: relative;

      &::before {
        content: " ";
        position: absolute;
        left: 0;
        top: 7px;
        border-width: 5px;
        border-color: transparent;
        border-top-color: transparent;
        border-style: solid;
        width: 0;
        height: 0;
      }

      &.negative {
        color: #e6643c;
        padding-left: 15px;

        &::before {
          border-top-color: #e6643c;
          border-bottom-color: transparent;
        }
      }

      &.positive {
        color: var(--primary-color);
        padding-left: 15px;

        &::before {
          top: 2px;
          border-bottom-color: var(--primary-color);
          border-top-color: transparent;
        }
      }

      & > div {
        color: #b5b5b5;
        font-size: 15px;
      }
    }
  }
</style>
